module.exports = __webpack_public_path__ + "static/img/20.b647751.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/2/zh/20.png
// module id = CU+q
// module chunks = 0